import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import mynaLogo from "@/assets/myna-logo.svg";

const NAV = {
  Platform: [
    { label: "How It Works", to: "/how-it-works" },
    { label: "Pricing", to: "/pricing" },
    { label: "Request Demo", to: "/request-demo" },
  ],
  Solutions: [
    { label: "Home Services & HVAC", to: "/solutions" },
    { label: "Mortgage Brokers", to: "/solutions/mortgage-brokers" },
    { label: "Custom Projects", to: "/request-demo" },
  ],
  Company: [
    { label: "About", to: "/about" },
    { label: "Book Demo", to: "/request-demo" },
    { label: "Contact", href: "mailto:support@myna-ai.co" },
  ],
  Legal: [
    { label: "Terms of Service", to: "/terms" },
    { label: "Privacy Policy", to: "/privacy" },
  ],
};

export const Footer = () => (
  <footer className="bg-[var(--m-footer)] border-t border-[var(--m-border)]">
    {/* CTA strip */}
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8 border-b border-[var(--m-border)]">
      <div className="flex flex-col gap-2">
        <Link to="/" className="inline-block">
          <img src={mynaLogo} alt="Myna AI" className="h-20 w-auto" />
        </Link>
        <p className="text-[var(--m-muted)] text-sm max-w-xs leading-relaxed">
          Custom AI-powered business platforms — voice receptionist, website, booking, reputation &amp; SEO. Everything a service business needs to grow.
        </p>
      </div>

      <div className="flex flex-col items-start sm:items-end gap-3">
        <Link
          to="/request-demo"
          className="inline-flex items-center gap-2 bg-lime-400 hover:bg-lime-500 text-black text-sm font-semibold px-5 py-2.5 transition-colors"
        >
          Book a Consultation
          <ArrowRight className="w-4 h-4" />
        </Link>
        <a
          href="mailto:support@myna-ai.co"
          className="text-lime-400/70 hover:text-lime-400 text-sm transition-colors"
        >
          support@myna-ai.co
        </a>
      </div>
    </div>

    {/* Link columns */}
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
      {(Object.entries(NAV) as [string, { label: string; to?: string; href?: string }[]][]).map(
        ([heading, links]) => (
          <div key={heading}>
            <h3 className="text-[var(--m-heading)] text-xs font-semibold uppercase tracking-widest mb-4">
              {heading}
            </h3>
            <ul className="space-y-3">
              {links.map(({ label, to, href }) => (
                <li key={label}>
                  {to ? (
                    <Link
                      to={to}
                      className="text-[var(--m-muted)] hover:text-[var(--m-heading)] text-sm transition-colors"
                    >
                      {label}
                    </Link>
                  ) : (
                    <a
                      href={href}
                      className="text-[var(--m-muted)] hover:text-[var(--m-heading)] text-sm transition-colors"
                    >
                      {label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )
      )}
    </div>

    {/* Bottom bar */}
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 border-t border-[var(--m-border)] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--m-subtle)]">
      <span>© 2026 Myna AI. All rights reserved.</span>
      <span className="flex items-center gap-3">
        <span>Serving US 🇺🇸 &amp; Canada 🇨🇦</span>
      </span>
    </div>
  </footer>
);
